// extracted by mini-css-extract-plugin
module.exports = {"item":"JobItemList_item__3qf-R","sending":"JobItemList_sending__2_k79"};